﻿$.fn.dxCtrlSondageQuestionOuiNon = function custom_dxCtrlSondageQuestionOuiNon(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestionouinon dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionOuiNon(this, option));
    }
    return this;
}

window.cdxCtrlSondageQuestionOuiNon = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        //$("<div style='font-size:140%;'/>").appendTo(container).html("OUI/NON")
        $("<div style='font-style:italic;font-size:80%;'/>").appendTo(container).html("Permet de déterminer si la question suivante doit être affichée:<br/>si la réponse est<strong>Oui</strong>, la ou les questions suivantes sont affichées(jusqu'au prochaine OUI/NON ou jusqu'à la fin);<br/>si la réponse est <strong> Non</strong>, les questions dépendantes sont ignorées et l'utilisateur peut passer à la page suivante.<br/>exemple:<br/>« Utilisez-vous ce service ? »<br/> → <strong>Oui</strong>: affichage des questions complémentaires;<br/> → <strong>Non</strong>: possibilité de passer à la page suivante.")

        $("<div style='margin-top:20px;'/>").appendTo(container).dxCtrlHtmlEditorSimple({
            labelMode: "floating",
            label: "Texte d'introduction à la question",
            value: option.dataQuestion.text_intro,
            onValueChanged: function (e) {
                debugger;
                option.dataQuestion.text_intro = (e.value == null ? "" : e.value)
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}